export const routes = {
  LANDING: '/',
  ADD_CARD: '/categories/:category/addcard',
  CATEGORY: '/categories/:category',
  CATEGROIES: '/categories'
};
